import React from 'react';

export const CustomerProfileApplicationSkeleton = () => {
  return <div className="skeleton grow h-[210px] bg-white border-hawkes-blue border-2 rounded-lg"></div>;
};
